import { render, staticRenderFns } from "./SearchResultSupport.vue?vue&type=template&id=31516159&"
import script from "./SearchResultSupport.vue?vue&type=script&lang=js&"
export * from "./SearchResultSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports